function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M43.5126 7.50167C53.4612 17.4581 53.4548 33.5942 43.4984 43.5428C33.5419 53.4913 17.4058 53.4849 7.45726 43.5285C-2.48575 33.5777 -2.48575 17.4526 7.45726 7.50167C17.3491 -2.45478 33.4394 -2.50703 43.3958 7.38485C43.4349 7.42365 43.4738 7.46259 43.5126 7.50167Z",
  fill: "#DDF6FF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M38.1545 17.276L29.9009 25.5297L38.1545 33.7833L33.7381 38.1997L25.4845 29.9461L17.231 38.1997L12.8145 33.7833L21.0682 25.5297L12.8145 17.276L17.231 12.8596L25.4845 21.1132L33.7381 12.8596L38.1545 17.276Z",
  fill: "#181935"
});

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6451a07235a1a44f9754a6869ff098eb.svg";
export { ForwardRef as ReactComponent };